import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Annonce } from 'app/models/annonce';
import { AwscontrolService } from 'app/services/aws/awscontrol.service'; // Import AWS service
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AnnonceService {
  
  base_path = 'https://annoncebackenderr.vercel.app/Annances/';
  base_path_edit = 'https://annoncebackenderr.vercel.app/Annances/edit';
  
  constructor(
    private http: HttpClient,
    private awsService: AwscontrolService // Inject AWS service
  ) {}

  // Method to upload a photo to S3 using the centralized service
  uploadPhoto(file: File): Promise<string> {
    return new Promise((resolve, reject) => {
      this.awsService.uploadFile(file, 'annonces').subscribe({
        next: (response) => {
          if (response.success && response.urls.length > 0) {
            resolve(response.urls[0]); // Return the first URL
          } else {
            reject(response.error || 'Upload failed');
          }
        },
        error: (err) => {
          reject(err.message || 'Upload error');
        }
      });
    });
  }

  // Method to upload multiple photos to S3
  uploadPhotos(files: File[]): Promise<string[]> {
    return new Promise((resolve, reject) => {
      this.awsService.uploadFiles(files, 'annonces').subscribe({
        next: (response) => {
          if (response.success) {
            resolve(response.urls); // Return all URLs
          } else {
            reject(response.error || 'Upload failed');
          }
        },
        error: (err) => {
          reject(err.message || 'Upload error');
        }
      });
    });
  }

  // Method to delete a photo from S3
  deletePhoto(fileUrl: string): Promise<boolean> {
    return new Promise((resolve, reject) => {
      this.awsService.deleteFile(fileUrl).subscribe({
        next: (response) => {
          if (response.status === 'success') {
            resolve(true);
          } else {
            reject(response.error || 'Delete failed');
          }
        },
        error: (err) => {
          reject(err.message || 'Delete error');
        }
      });
    });
  }

  // API call to create an announcement
  createAnnonce(annonceData: any): Observable<any> {
    return this.http.post(this.base_path + 'ajouter', annonceData);
  }

  getAnnouncements(): Observable<any> {
    return this.http.get(this.base_path + 'all-annonce');
  }

  getAnnouncementsAttente(): Observable<any> {
    return this.http.get(this.base_path + 'VuInapproved/all');
  }
  
  getAnnouncementNonVu(): Observable<any> {
    return this.http.get(this.base_path + 'AnnoncesNonVu/all');
  }

  deleteItem(id: string): Observable<any> {
    return this.http.delete(this.base_path + 'delete/' + id);
  }

  getAnnonceDetails(id: string): Observable<any> {
    return this.http.get(this.base_path + 'moveNonVu/' + id);
  }

  getAnnonce(id: string): Observable<any> {
    return this.http.get(this.base_path + id);
  }

  updateAnnonce(id: string, data: any): Observable<any> {
    return this.http.put(this.base_path_edit + id, data);
  }

  editAnnonce(id: string, data: Partial<Annonce>): Observable<Annonce> {
    return this.http.put<Annonce>(`${this.base_path_edit}/${id}`, data);
  }

  approveAnnouncement(id: any): Observable<any> {
    const url = `${this.base_path}approver/${id}`;
    return this.http.put(url, {});
  }

  // Helper method to extract filename from URL (moved from awscontrolService for convenience)
  extractFileName(fileUrl: string): string {
    return fileUrl.substring(fileUrl.lastIndexOf('/') + 1);
  }

  // Helper method to generate S3 URL (moved from awscontrolService for convenience)
  generateS3Url(fileName: string, folder?: string): string {
    return this.awsService.generateS3Url(fileName, folder);
  }

  // Check AWS S3 connection health
  checkHealth(): Observable<any> {
    return this.awsService.checkHealth();
  }
}